// 📄 pages/Proyectos/MiEspacioProyecto.tsx
// "Mi Espacio en el Proyecto" — vive en /proyecto/:projectId/mi-espacio,
// dentro del grupo "Herramientas" del sidebar. Mismas 4 secciones que Mi
// Espacio Global (ver pages/MiEspacio/), pero con un único contexto fijo:
// este proyecto. Privado por diseño (usuarios/{uid}/projectData/{projectId}/...
// — ver miEspacioService.ts): aunque el proyecto tenga varios miembros,
// nadie más ve lo que un consultor guarda acá, ni siquiera el PM.
import { Lock } from 'lucide-react';
import { useProject } from '../../context/ProjectContext.tsx';
import MiEspacioTabs from '../MiEspacio/MiEspacioTabs.tsx';
import MiEspacioPinGate from '../MiEspacio/components/MiEspacioPinGate.tsx';

export default function MiEspacioProyecto() {
  const { projectId } = useProject();

  return (
    <div className="space-y-6">
      <div className="bg-blue-500/10 border border-blue-500/20 text-blue-300 p-3 rounded-lg text-xs flex items-start gap-2">
        <Lock className="w-4 h-4 flex-shrink-0 mt-0.5" />
        <span>Espacio personal dentro de este proyecto: snippets, notas de SAP, pendientes y contactos que solo tú puedes ver, aunque otros miembros del equipo también tengan acceso al proyecto.</span>
      </div>

      <MiEspacioPinGate>
        <MiEspacioTabs
          contextosConsulta={[projectId]}
          contextoNuevo={projectId}
          proyectosPorId={{}}
        />
      </MiEspacioPinGate>
    </div>
  );
}
